import React, { useState } from "react";

const categorySuggestions = {
    Tech: ["AI", "Web3", "SaaS", "Cloud", "Open Source", "Blockchain", "Robotics", "Cybersecurity"],
    Art: ["Illustration", "NFT", "Animation", "Digital Art", "Painting", "Sculpture", "Mixed Media"],
    Music: ["Jazz", "Hip-Hop", "Indie", "Studio", "Soundtracks", "Electronic", "Classical"],
    Science: ["Biotech", "Space", "Quantum", "Physics", "Experiments", "Genetics", "Astrobiology"],
    Content: ["Film", "Photography", "Writing", "Podcasts", "Short Films", "Vlogs", "Creative Writing"],
    Fashion: ["Clothing", "Accessories", "Styling", "Streetwear", "High Fashion", "Textile Design"],
    Gaming: ["Video Games", "Board Games", "Esports", "Indie Games", "Virtual Reality", "Tabletop RPGs"],
    Food: ["Recipes", "Culinary Creations", "Food Startups", "Gastronomy", "Baking", "Food Science"],
    Craft: ["Interior Design", "Furniture", "Home Innovations", "DIY", "Sustainable Living", "Handmade Decor"]
};
  

const TagInput = ({ selectedCategory, onTagsChange }) => {
  const [tags, setTags] = useState([]);
  const [inputValue, setInputValue] = useState("");

  const handleTagKeyPress = (e) => {
    if (e.key === "Enter" && inputValue.trim()) {
      e.preventDefault();
      const newTag = inputValue.trim();

      if (tags.includes(newTag) || tags.length >= 7) return;

      const updatedTags = [...tags, newTag];
      setTags(updatedTags);
      onTagsChange(updatedTags);
      setInputValue("");
    }
  };

  const handleRemoveTag = (tagToRemove) => {
    const updatedTags = tags.filter((tag) => tag !== tagToRemove);
    setTags(updatedTags);
    onTagsChange(updatedTags);
  };

  const handleSuggestedTagClick = (tag) => {
    if (!tags.includes(tag) && tags.length < 7) {
      const updatedTags = [...tags, tag];
      setTags(updatedTags);
      onTagsChange(updatedTags);
    }
  };

  return (
    <div style={styles.container}>
        <div style={styles.topRow}>
          <input
            type="text"
            placeholder="Press Enter to Add a Tag"
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
            onKeyPress={handleTagKeyPress}
            style={styles.input}
          />

          <div style={styles.tagList}>
            {tags.map((tag, index) => (
              <span key={index} style={styles.tag}>
                {tag}
                <span onClick={() => handleRemoveTag(tag)} style={styles.removeTag}>×</span>
              </span>
            ))}
          </div>
        </div>

        {tags.length >= 7 && <p style={styles.limitMessage}>Max 7 tags allowed</p>}

        {selectedCategory && categorySuggestions[selectedCategory] && (
          <div style={styles.suggestions}>
            <strong>Suggested: </strong>
            {categorySuggestions[selectedCategory].map((suggestedTag) => (
              <span
                key={suggestedTag}
                style={styles.suggestionTag}
                onClick={() => handleSuggestedTagClick(suggestedTag)}
              >
                {suggestedTag}
              </span>
            ))}
          </div>
        )}
    </div>
  );
};

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    gap: "10px",
  },
  topRow: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    gap: "16px",
    width: "100%",
  },
  input: {
    padding: "12px",
    fontSize: "14px",
    borderRadius: "12px",
    border: "1px solid #ddd",
    background: "#f9f9f9",
    flex: "1",
    minWidth: "220px",
  },
  tagList: {
    display: "flex",
    flexWrap: "wrap",
    gap: "6px",
    flex: "2",
    maxWidth: "400px",
    alignItems: "flex-start",
    marginTop: "4px",
  },
  tag: {
    display: "inline-flex",
    alignItems: "center",
    background: "#0077B5",
    color: "#fff",
    padding: "6px 12px",
    borderRadius: "16px",
    fontSize: "14px",
    fontWeight: "500",
    cursor: "pointer",
    transition: "background 0.3s ease",
  },
  removeTag: {
    marginLeft: "8px",
    cursor: "pointer",
    fontWeight: "bold",
  },
  suggestions: {
    display: "flex",
    flexWrap: "wrap",
    gap: "6px",
    fontSize: "14px",
    color: "#666",
  },
  suggestionTag: {
    padding: "5px 10px",
    background: "#e0e0e0",
    borderRadius: "12px",
    cursor: "pointer",
    transition: "background 0.3s ease",
  },
  limitMessage: {
    fontSize: "12px",
    color: "red",
  },
};


export default TagInput;
